export default __webpack_public_path__ + "static/sign-ae9fa4253a89d72a4244eb4f84c21b99.png";